module.exports = __webpack_public_path__ + "static/media/007 I GUERRA M_Centro psichiatrico.cfb4299a.svg";